import { render, staticRenderFns } from "./FixedCalculationBasis.vue?vue&type=template&id=2ff72a67&scoped=true&"
import script from "./FixedCalculationBasis.vue?vue&type=script&lang=ts&"
export * from "./FixedCalculationBasis.vue?vue&type=script&lang=ts&"
import style0 from "./FixedCalculationBasis.vue?vue&type=style&index=0&id=2ff72a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff72a67",
  null
  
)

export default component.exports